import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { ROUTES } from '../../server-route';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RejectReviewService extends ApiService {
  public rejectMemdata(memCode: string, payLoad: any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.REJECTION, {
        memCode: memCode,
      }),
      {
        body: payLoad,
      }
    );
  }
}
